import { useQuery } from "@tanstack/react-query";
import { getDriver } from "services/driver";

const useDriver = () => {
  const query = useQuery({
    queryKey: ["GET_DRIVER"],
    queryFn: getDriver,
  });

  return query;
};
export default useDriver;
